import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const UNIT_EXPLAINER = "A unit is a standard amount used to track betting performance. It helps compare results regardless of the amount wagered.";

export function UnitsHeading({ label = "Units" }) {
  return (
    <span className="inline-flex items-center gap-1">
      {label}
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" aria-label="What is a unit?" data-testid="units-info-btn" className="inline-flex h-6 w-6 items-center justify-center rounded-full text-slate-500 transition-colors hover:text-[#00E676] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#00E676]/60">
            <Info size={13} />
          </button>
        </PopoverTrigger>
        <PopoverContent side="top" align="start" className="w-72 border-[#1E2738] bg-[#141A26] p-4 text-sm normal-case tracking-normal text-slate-200 shadow-2xl" data-testid="units-info-popover">
          <p className="font-display text-xs font-bold uppercase tracking-wider text-[#00E676]">Betting units</p>
          <p className="mt-1.5 leading-relaxed">{UNIT_EXPLAINER}</p>
        </PopoverContent>
      </Popover>
    </span>
  );
}
